'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getActiveLanguageAndCountryCode = exports.default = exports.isChangeLanguageAction = exports.changeLanguageAction = exports.reducers = exports.constants = undefined;

var _actions = require('./actions');

Object.defineProperty(exports, 'changeLanguageAction', {
    enumerable: true,
    get: function get() {
        return _actions.changeLanguageAction;
    }
});
Object.defineProperty(exports, 'isChangeLanguageAction', {
    enumerable: true,
    get: function get() {
        return _actions.isChangeLanguageAction;
    }
});

var _selectors = require('./selectors');

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _selectors.getActiveLanguageCode;
    }
});
Object.defineProperty(exports, 'getActiveLanguageAndCountryCode', {
    enumerable: true,
    get: function get() {
        return _selectors.getActiveLanguageAndCountryCode;
    }
});

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

var _reducer = require('./reducer');

var reducers = _interopRequireWildcard(_reducer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.constants = constants;
exports.reducers = reducers;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/language-common/dist/main/index.js
// module id = 94
// module chunks = 0